import { makeStyles, fade } from '@material-ui/core/styles';

const IMAGE = 100;

const useStyles = makeStyles((theme) => ({
  cpScoreHeaderChild: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
    '@media print': {
      display: 'block',
    },
    width: 48,
    minWidth: 48,
    textAlign: 'center',
    margin: 0,
  },
  headerChildName: {
    margin: 0,
    marginRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    overflowX: 'auto',
  },
  checklist: {
    pageBreakInside: 'avoid',
  },
  checklistFirst: {
    pageBreakBefore: 'avoid',
  },
  checklistHeader: {
    top: 48,
    zIndex: 2,
    paddingLeft: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    clear: 'both',
  },
  checklistHeaderBorder: {
    borderBottom: '1px solid lightgrey',
  },
  checklistHeaderCourse: {
    zIndex: 2,
    paddingLeft: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    borderBottom: '1px solid lightgrey',
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  checklistContainerPrint: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    '& .IMAGE': {
      float: 'right',
      width: '40%',
      paddingLeft: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
  headerBtn: {
    color: 'red',
  },
  headerCriteria: {
    lineHeight: 0,
    position: 'absolute',
    fontSize: '10px',
    bottom: theme.spacing(1),
    color: theme.colors.grey,
    fontWeight: 'normal',
  },
  checklistImage: {
    cursor: 'pointer',
    '& :hover': {
      opacity: 0.8,
    },

    '& .IMAGE': {
      [theme.breakpoints.up('md')]: {
        position: 'sticky',
        top: 110,
      },
    },
  },
  row: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  rowIndent: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    marginLeft: theme.spacing(3),
  },
  rowTop: {
    display: 'flex',
    alignItems: 'flex-start',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'center',
    },
    '@media print': {
      alignItems: 'baseline',
    },
  },
  moreIcon: {
    marginLeft: 'auto',
  },
  link: {
    marginLeft: theme.spacing(2),
    color: theme.palette.secondary.main,
    textDecoration: 'none',
    fontStyle: 'italic',
    fontWeight: 'bold',
    fontSize: 14,
    padding: theme.spacing(1),
  },
  images: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  imagesprint: {
    '& .caption': {
      color: theme.palette.text.primary,
    },
  },
  imageWrap: {
    height: IMAGE,
    width: IMAGE,
  },
  image: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: IMAGE,
    '&:hover': {
      cursor: 'pointer',
      opacity: '0.7',
    },
  },
  topic: {
    padding: '6px 6px 6px 16px',
    pageBreakInside: 'avoid !important',
  },
  cpscoreHidden: {
    marginLeft: 72,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 24,
    },
  },
  criteria: {
    color: 'red',
    fontSize: 12,
    marginBottom: theme.spacing(1),
  },
  progWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 150,
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  grow: {
    flexGrow: 1,
  },
  edit: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  sentinel: {
    left: 0,
    right: 0,
    top: -60,
    height: 12,
    position: 'absolute',
    visibility: 'hidden',
  },
  spacerTop: {
    height: theme.spacing(2),
  },
  spacerBottom: {
    height: theme.spacing(4),
  },
  loadContainer: {
    height: 4,
    width: '100%',
  },
  imgCaption: {
    color: theme.palette.text.secondary,
    fontSize: 10,
  },
  buttonRoot: {
    [theme.breakpoints.down('sm')]: {
      minWidth: 48,
    },
  },

  rComment: {
    width: '100%',
    backgroundColor: fade(theme.colors.red, 0.2),
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    boxSizing: 'border-box',
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(4),
    maxWidth: `calc(100% - ${theme.spacing(4)}px)`,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      maxWidth: '100%',
    },

    '& .column': {
      maxWidth: `calc(100% - ${theme.spacing(5)}px)`,
      alignItems: 'flex-start',
      marginLeft: theme.spacing(4),
    },

    '& .textContainer': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      width: '100%',
    },

    '& .MuiTextField-root': {
      width: '100%',
    },
    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.background.paper,
    },
    '& .textRow': {
      justifyContent: 'space-between',
      position: 'relative',

      '& .indicator': {
        position: 'absolute',
        left: -20,
        width: 16,
        height: 16,
        borderRadius: 16,
        backgroundColor: theme.colors.black,
      },
    },
    '& .btnRow': {
      justifyContent: 'flex-end',

      '& button': {
        marginLeft: theme.spacing(1),
      },
    },
  },

  rCommentCheckpointEdit: {
    marginLeft: 0,
    maxWidth: '100%',
  },
}));

export default useStyles;
